export default __webpack_public_path__ + "static/accordion-opened-mobile-f1a579b1de82839b3f737db465c00018.png";